import { isString, isObject } from 'lodash'
import { getValue } from 'public/components/kye-table2/utils'
import { decrypt } from 'public/utils/common'
import { createKeys } from './decrypt-max-plugin'

const matchEncrypteSymbol = (t, encrypteSymbol) => t.includes(encrypteSymbol)

class DecryptApi {
  constructor() {
    /**
     * @overview 加密配置
     */
    this.config = {
      ENCRYPTE_MASK_SYMBOL: '*',
      ENCRYPTE_MASKSEC_SYMBOL: '✽',
      MASK_KEY: 'Mask',
      VIRTUAL_KEY: 'Virtual',
      MASKSEC_KEY: 'MaskSec'
    }
    this.bindMethodThis()
  }

  /**
   * @overview 获取不同加密类型key
   * @param {key} 数据key名称
   */
  getMaskKey(key) {
    const { MASK_KEY } = this.config
    return `${key}${MASK_KEY}`
  }
  getVirtualkey(key) {
    const { VIRTUAL_KEY } = this.config
    return `${key}${VIRTUAL_KEY}`
  }
  getMaskSeckey(key) {
    const { MASKSEC_KEY } = this.config
    return `${key}${MASKSEC_KEY}`
  }

  isEncryptedByString(d = {}, key) {
    if (!isObject(d)) d = d + ''
    const val = isString(d) ? d : getValue(key, d)
    if (!val) return false
    const { ENCRYPTE_MASK_SYMBOL, ENCRYPTE_MASKSEC_SYMBOL } = this.config
    return !!matchEncrypteSymbol(val, ENCRYPTE_MASK_SYMBOL) || !!matchEncrypteSymbol(val, ENCRYPTE_MASKSEC_SYMBOL)
  }

  /**
   * @overview 是否加密状态
   * @param {d} 数据对象
   * @param {key} 数据key名称
   */
  isEncrypteStatus(d, key) {
    if (!isObject(d)) d = d + ''
    if (d && isString(d)) {
      return this.isEncryptedByString(d)
    } else {
      const plaintext = getValue(key, d)
      return !!(this.getEncrypteText(d, key) && this.isEncryptedByString(plaintext))
    }
  }

  /**
   * @overview 是否加密类型
   * @param {d} 数据对象
   * @param {key} 数据key名称
   */
  isEncrypted(d, key) {
    if (!isObject(d)) d = d + ''
    if (d && isString(d)) {
      return this.isEncryptedByString(d)
    } else {
      const _isEncrypted = this.isMask(d, key) || this.isVirtual(d, key) || this.isMaskSec(d, key)
      // // 存在批量解密的场景，批量解密场景默认
      const isBatchDecrypt = this.isBatchDecrypt(d, key)
      return !isBatchDecrypt && _isEncrypted
    }
  }

  /**
   * @overview 获取密文
   * @param {d} 数据对象
   * @param {key} 数据key名称
   */
  getEncrypteText(d, key) {
    return this.getMaskVal(d, key) || this.getVirtualVal(d, key) || this.getMaskSecVal(d, key)
  }

  /**
   * @overview 判断是否加密字段
   * @param {d} 数据对象
   * @param {key} 数据key名称
   */
  isMask(d, key) {
    const decryptKey = this.getMaskKey(key)
    return this.isHasEncryptKey(d, decryptKey)
  }
  getMaskVal(d, key) {
    const decryptKey = this.getMaskKey(key)
    return this.getValue(d, decryptKey)
  }

  /**
   * @overview 判断是否虚拟号
   * @param {d} 数据对象
   * @param {key} 数据key名称
   */
  isVirtual(d, key) {
    const decryptKey = this.getVirtualkey(key)
    return this.isHasEncryptKey(d, decryptKey)
  }
  getVirtualVal(d, key) {
    const decryptKey = this.getVirtualkey(key)
    return this.getValue(d, decryptKey)
  }

  /**
   * @overview 判断是否敏感字段
   * @param {d} 数据对象
   * @param {key} 数据key名称
   */
  isMaskSec(d, key) {
    const decryptKey = this.getMaskSeckey(key)
    return this.isHasEncryptKey(d, decryptKey)
  }
  /**
   * @overview 通过内容字符串判断是否敏感字段
   * @param {d} 数据对象
   * @param {key} 数据key名称
   */
  isMaskSecByString(d, key) {
    const val = this.getValue(d, key)
    if (!val) return false
    const { ENCRYPTE_MASKSEC_SYMBOL } = this.config
    return !!matchEncrypteSymbol(val, ENCRYPTE_MASKSEC_SYMBOL)
  }
  getMaskSecVal(d, key) {
    const decryptKey = this.getMaskSeckey(key)
    return this.getValue(d, decryptKey)
  }

  /**
   * @overview 解密方法
   * @returnType {Promise}
   * @param {type} 解密类型 ['mask', 'virtual']
   * @param {params} 加密对象
   * @property {params.fieldName} 字段名(必填)
   * @property {params.fieldContent} 字段内容，加密值(必填)
   * @property {params.dataId} 唯一值，通常用的数据id(必填)
   * @property {params.buttonName} 按钮名称(必填)
   * @property {params.fieldNameStr} 字段中文名，类似from表单的label
   */
  decrypt(params, type = 'mask') {
    return decrypt(params, type)
  }

  /**
   * @overview 是否存在加密key
   * @param {d} 数据对象
   * @param {key} 数据key名称
   */
  isHasEncryptKey(obj, key) {
    if (!obj || !key) return false
    const keys = key.split('.')
    let current = obj
    for (const key of keys) {
      if (!current || !Object.prototype.hasOwnProperty.call(current, key)) {
        return false
      }
      current = current[key]
    }
    return true
  }

  getValue(d, key) {
    if (!isObject(d)) d = d + ''
    return isString(d) ? d : getValue(key, d)
  }

  /**
   * @overview 批量解密
   */
  batchDecrypt() {
    console.log('批量解密')
  }

  /**
   * @overview 关于this的绑定
   */
  bindMethodThis() {
    const methods = Object.getOwnPropertyNames(DecryptApi.prototype).filter(
      prop => typeof this[prop] === 'function' && prop !== 'constructor'
    )
    for (const method of methods) {
      this[method] = this[method].bind(this)
    }
  }

  /**
   * @overview 检测是否是批量解密数据
   */
  isBatchDecrypt(d = {}, key) {
    try {
      const { keyDecryptOrder } = createKeys(key)
      const hasBatchDecrypt = d.hasOwnProperty(keyDecryptOrder)
      return hasBatchDecrypt
    } catch (e) {
      console.log(e)
      return false
    }
  }
}

const decryptApi = new DecryptApi()

export {
  decryptApi
}



// WEBPACK FOOTER //
// ./src/public/utils/decrypt-api.js